import { GET } from 'utils/requests.utils'

const BASE_URL = '/app/email_logs'

export const fetchItem = (token) => GET(`${BASE_URL}/${token}`)

export default fetchItem
